module.exports = __webpack_public_path__ + "static/media/chess-king-alt.a935246f.svg";